import { defaultTo, find } from 'lodash';
import * as React from 'react';
import { RenderLeafProps } from 'slate-react';
import styled from 'styled-components';

import { setDefaults } from '../../../../slatePlugins/common/utils/setDefaults';
import { DEFAULT_BG_COLOR, MARK_BG_COLOR } from './defaults';
import { BackgroundColorLeafProps, BackgroundColorMarkPluginOptions } from './types';

const StyledBgColor = styled.span<{ color: string }>`
  background-color: ${(p) => p.color};
  padding: 2px 0;
`;

export const renderLeafBackgroundColor =
  (options: BackgroundColorMarkPluginOptions) =>
  ({ children, leaf }: RenderLeafProps) => {
    if (leaf[MARK_BG_COLOR] && !!leaf.text) {
      const { colorKey } = leaf[MARK_BG_COLOR] as BackgroundColorLeafProps;
      const { colors, defaultColor } = setDefaults(options, DEFAULT_BG_COLOR.bgColor);
      const color = defaultTo(
        find(colors, (cl) => cl.key === colorKey),
        defaultColor
      );
      return (
        <StyledBgColor color={color.color} className="slate-bg-color">
          {children}
        </StyledBgColor>
      );
    }
    return children;
  };
